exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product__rating[data-v-0d18c1db]{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;margin:var(--spacer-xs) 0 0 0}.product__count[data-v-0d18c1db]{color:var(--c-text);text-decoration:none;margin:0 0 0 var(--spacer-xs)}\n", ""]);

// exports
